import React, { useCallback, useState } from 'react';

import Select, { SelectOption } from 'corp/components/UI/Select';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';

type Props = {
  placeholder?: string;
  onChange: (option: SelectOption) => void;
  value: SelectOption | null;
  width?: string;
};

type Response = {
  qualifications: any[];
};

const SelectQualification = (props: Props) => {
  const [curTimeout, setCurTimeout] = useState<NodeJS.Timeout | null>(null);

  const fetchQualifications = useCallback(
    async (name: any) => {
      if (!name) {
        return (async () => [])();
      }

      if (curTimeout) {
        clearTimeout(curTimeout);
      }

      return new Promise(resolve => {
        const newTimeout = setTimeout(async () => {
          try {
            const { qualifications } = await apiFetch<Response>(
              null,
              `corp-api/find/qualification?name=${name}`,
            );
            resolve({
              options: qualifications.map(qualification => ({
                label: qualification.name,
                value: qualification.id,
              })),
            });
          } catch (error) {
            defaultApiFetchErrorHandler(error, { handleHttp: true });
          }
          return [];
        }, 500);
        setCurTimeout(newTimeout);
      });
    },
    [curTimeout],
  );

  return <Select loadOptions={fetchQualifications} {...props} />;
};

export default SelectQualification;
